import core from '@/helpers/client'

const attributesetsService = {
  async headAttributeSetsMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets`,
      params
    )
    return result
  },
  async getAttributeSetsMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets`,
      params
    )
    return result
  },
  async getAttributeSetsMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/${id}`
    )
    return result
  },
  async getAttributeSetProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/${id}/skus`
    )
    return result
  },
  async getAttributeSetDeleteAbleByIdAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/${id}/deleteable`
    )
    return result
  },
  async getAttributesByAttributeSetAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/attributes`,
      params
    )
    return result
  },
  async createAttributeSetsMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets`,
      model
    )
    return result
  },
  async updateAttributeSetsMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/${id}`,
      model
    )
    return result
  },
  async deleteAttributeSetsMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/attributesets/delete/${id}`
    )
    return result
  },
}
export default attributesetsService
